import { Cloud, K8sProvider } from '@cast/shared-types';
import {
  KentRebalancingPlanStatusEnum,
  RebalancingPlanStatusEnum,
} from '@cast/types';

export const REBALANCING_IN_PROGRESS_STATES: RebalancingPlanStatusEnum[] = [
  RebalancingPlanStatusEnum.creating_nodes,
  RebalancingPlanStatusEnum.draining_nodes,
  RebalancingPlanStatusEnum.preparing_nodes,
  RebalancingPlanStatusEnum.deleting_nodes,
];

export const KENT_REBALANCING_IN_PROGRESS_STATES: KentRebalancingPlanStatusEnum[] =
  [KentRebalancingPlanStatusEnum.EXECUTING];

export const EXECUTED_REBALANCING_STATES: RebalancingPlanStatusEnum[] = [
  RebalancingPlanStatusEnum.finished,
  RebalancingPlanStatusEnum.partially_finished,
  RebalancingPlanStatusEnum.error,
];

export const KENT_EXECUTED_REBALANCING_STATES: KentRebalancingPlanStatusEnum[] =
  [
    KentRebalancingPlanStatusEnum.COMPLETED,
    KentRebalancingPlanStatusEnum.PARTIALLY_COMPLETED,
    KentRebalancingPlanStatusEnum.FAILED,
  ];

export const SUPPORTS_STORAGE: K8sProvider[] = [
  K8sProvider.GKE,
  K8sProvider.EKS,
  K8sProvider.AKS,
];

export const SUPPORTS_COMMITMENTS = [
  K8sProvider.AKS,
  K8sProvider.GKE,
  K8sProvider.EKS,
] as const;

export const drainFailedAnnotation = 'rebalancing.cast.ai/status=drain-failed';

export const CONNECT_CLOUD_PROVIDERS: Cloud[] = [
  Cloud.gcp,
  Cloud.aws,
  Cloud.azure,
  Cloud.oracle,
];

export const SUPPORTS_CONNECT_CLOUD: Cloud[] = [
  Cloud.gcp,
  Cloud.aws,
  Cloud.azure,
  Cloud.oracle,
];
